import React from 'react';
import { createRoot } from 'react-dom/client';
//import './styles/index.css';
import './styles/globals.css'

import Authentication from './Authentication';

import reportWebVitals from './reportWebVitals';

const container: any = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Authentication />
  </React.StrictMode>,
  //document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
